.field-row > div:nth-child(2) p {
  margin: 0;
}
